// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "4777" ? "monaco-editor" : chunkId) + "." + {"4679": "2c8323b1","4777": "13f44d2c","4896": "0a49cdea","5213": "f0cf749e","631": "e66fee72","6536": "e5b33855","7075": "2c7a2371",}[chunkId] + ".css"
}